import * as clipboard from 'clipboard-polyfill';
import Content from 'js/components-v2/pages/UserDashboard/Content';
import Sidebar from 'js/components-v2/pages/UserDashboard/Sidebar';
import AppContent from 'js/components/AppContent';
import { AppButton } from 'js/new/Components/App';
import { useTruncate } from 'js/new/Hooks/useTruncate';
import Facebook from "js/services/Facebook";
import { formatCurrency } from "js/services/Format";
import { makeRequest } from "js/services/Network";
import AppState from 'js/stores/AppState';
import AppUser from "js/stores/AppUser";
import UserDashboardPageState from 'js/stores/pages/UserDashboardPageState';
import React, { useState } from 'react';

const Referrals = () => {
  const page = UserDashboardPageState.create();
  const [clicked, setClicked] = useState(false);
  const [refLink, setRefLink] = useState('generating...');
  const [refCount, setRefCount] = useState(0)
  const [rewardCount, setRewardCount] = useState(0)
  const [conversionRate, setConversionRate] = useState(0)
  const [referrals, setReferrals] = useState([])
  const [loading, setLoading] = useState(true)
  const [refBonusBalance, setRefBonusBalance] = useState(0);

  function copyLink() {
    clipboard.writeText(refLink);
    setClicked(true);

    setTimeout(() => setClicked(false), 5000);
  }

  function shareTo(target) {
    const title = "Sharing some POD " + <img src="/images/icons/love-51.png" alt="love" />
    if (navigator.share) {
      navigator.share({
        title,
        url: refLink,
        text: `Enjoy 500 naira bonus on your first transaction!`,
      });
    } else if (target === 'facebook') {
      Facebook.ui({
        method: 'share',
        href: refLink,
      });
    }
  }

  React.useEffect(async () => {
    AppState.setCurrentPage('UserDashboardPage');
    await page.load();
    const userAlias = AppUser.login;
    const urlPart = window.location.host + "/ref"
    setRefLink(`${urlPart}/${userAlias}`)
  }, []);

  React.useEffect(() => {
    makeRequest('referrals-dashboard-data', '', '')
      .then(response => {
        setReferrals(response.data?.refs);
        setLoading(false);
        setRefCount(response.data?.refs.lenght || 0);
        setRewardCount(response.data?.data?.signup_count || 0);
        if (response.data?.data?.visit_count > 0) {
          let rate = Number((response.data?.data?.signup_count / response.data?.data?.visit_count) * 100).toFixed(2)
          setConversionRate(parseFloat(rate));
        }

        setRefBonusBalance(response.data?.bonus?.bonus_balance)
      })
      .catch(error => {
      });
  }, []);

  return (
    <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
      <Sidebar currentPage='UserReferralsPage' pageState={page} />

      <Content currentPage='UserReferralsPage' showCards={false}>
        <div className='bg-white tw-p-4 md:tw-px-8 mt-3 tw-rounded-xl'>
          <h3 className="tw-mb-0">Referrals</h3>
        </div>

        <div className="tw-mt-3 new-pod-ui bg-white tw-grid md:tw-grid-cols-2 tw-gap-8 md:tw-gap-16 tw-p-4 md:tw-p-8">
          <div className="tw-space-y-4 md:tw-space-y-8">
            <h6>Refer <strong>6</strong> people and get <strong>{formatCurrency(AppUser.address?.country === 'US' ? 25 : 3000)}</strong>. Share your unique referral link</h6>

            <div style={{ border: "1px dashed #6D60F6", overflowWrap: "break-word" }} className='tw-text-center tw-p-6 tw-rounded-lg'>
              <h4 className='tw-mb-0'>{useTruncate(refLink)}</h4>
            </div>

            <div className='tw-text-center'>
              <AppButton onClick={copyLink} className='tw-w-full md:tw-max-w-sm'>
                {clicked === true ? 'Link Copied' : 'Copy link'}
              </AppButton>
            </div>

            <div className="tw-flex tw-items-center tw-gap-4">
              <hr style={{ borderTop: '2px solid gray' }} className='tw-flex-1' />
              <p className='tw-font-semibold'> or share to </p>
              <hr style={{ borderTop: '2px solid gray' }} className='tw-flex-1' />
            </div>

            <div className="tw-flex tw-justify-center tw-gap-4 md:tw-gap-8 tw-flex-wrap" style={{ border: "none" }}>
              {[
                { platform: 'twitter', icon: 'TwitterX' },
                { platform: 'facebook', icon: 'Facebook' },
                { platform: 'whatsapp', icon: 'WhatsApp' },
                { platform: 'instagram', icon: 'Insta' },
                { platform: 'tiktok', icon: 'TikTok' }
              ].map(({ platform, icon }) => (
                <div key={platform} style={{ cursor: 'pointer' }} onClick={(event) => shareTo(platform)}>
                  <img
                    src={`/images/icons/${icon}.png`}
                    alt={platform.charAt(0).toUpperCase() + platform.slice(1)}
                    className="tw-h-auto referral-share-icon"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="tw-space-y-4 md:tw-space-y-8">
            <div className="tw-p-4 tw-rounded-lg" style={{ border: "1px solid #6D60F6" }}>
              <p>Referral balance</p>
              <h4>{formatCurrency(refBonusBalance)}</h4>
            </div>

            <div className="tw-grid tw-grid-cols-3 tw-gap-4 md:tw-gap-8">
              {[
                { text: 'Total referrals', value: rewardCount > refCount ? rewardCount : refCount },
                { text: 'Total rewards', value: rewardCount },
                { text: 'Conversion rate', value: conversionRate + '%' }
              ].map(({ text, value }, i) => (
                <div key={i}>
                  <p>{text}</p>
                  <h4>{value}</h4>
                </div>
              ))}
            </div>

            {referrals.length < 1 ? (
              <div className='tw-text-center tw-space-y-4'>
                <img
                  src="/images/icons/empty-referral.svg"
                  alt="referrals"
                  className='tw-h-40 tw-w-auto'
                />

                <p>{loading ? 'Loading referrals...' : 'No referrals Yet'}</p>
              </div>
            ) : (
              <>
                <p>Referred Users</p>

                <table className="tw-overflow-x-auto">
                  <tbody>
                    {referrals.map((referral) => {
                      const { id, date, referred } = referral;
                      const status = 'Completed';
                      const amount = 500;

                      return (
                        <tr key={id}>
                          <td>
                            <img
                              src="/images/icons/successful.png"
                              alt="emphasis"
                              className={`status-success size-32px`}
                            />
                          </td>
                          <td>
                            <>
                              {status} <br />
                              <small>{referred} <strong> - </strong> {date}</small>
                            </>
                          </td>
                          <td>
                            <span className="tw-pt-tw-pb-4 tw-pb-4" style={{ fontSize: '14px', lineHeight: '20px', fontWeight: 600, verticalAlign: 'center' }}>{formatCurrency(amount)}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </Content>
    </AppContent>
  );
}

export default Referrals;
